module.exports = __webpack_public_path__ + "./docs/img/big-icon-error_list.f4da66ef6408a63db821f0608259d7b3.svg";